window.ProductItemForm = {
  toggle: function(toggleButton) {
    const productItem = toggleButton.closest('.product-item');
    const form = productItem.querySelector('.product-item-form');
    const iconPlus = toggleButton.querySelector('.icon-plus');
    const iconMinus = toggleButton.querySelector('.icon-minus');
    
    if (form.classList.contains('hidden')) {
      form.classList.remove('hidden');
      iconPlus.style.display = 'none';
      iconMinus.style.display = 'block';
    } else {
      form.classList.add('hidden');
      iconPlus.style.display = 'block';
      iconMinus.style.display = 'none';
    }
  },
  
  addToCart: function(formId, variantId = null, event) {
    event.stopPropagation();
    
    console.log('ProductItemForm.addToCart called:', { formId, variantId });
    
    // Check if this is coming from a plus button (single variant case)
    const isPlusButton = event.target.closest('button')?.querySelector('.icon-plus');
    let plusButton = null;
    let addingText = null;
    
    if (isPlusButton) {
      plusButton = event.target.closest('button');
      
      // Set loading state for plus button
      plusButton.disabled = true;
      plusButton.style.opacity = '0.7';
      
      // Add "adding..." text next to the button
      addingText = document.createElement('span');
      addingText.textContent = 'adding...';
      addingText.className = 'adding-text text-small text-gray-600 ml-2';
      plusButton.parentNode.appendChild(addingText);
    }
    
    // Use explicit variant ID if provided, otherwise get from VariantSelector
    let selectedVariantId = variantId;
    
    if (!selectedVariantId && window.VariantSelector) {
      selectedVariantId = window.VariantSelector.getSelectedVariantId(formId);
    }
    
    if (!selectedVariantId) {
      console.error('No variant ID available for product item');
      
      // Reset plus button state if there was an error
      if (plusButton && addingText) {
        this.resetPlusButtonState(plusButton, addingText);
      }
      
      return Promise.reject('No variant selected');
    }
    
    console.log('Adding variant to cart:', selectedVariantId);
    
    // Get product info from the product item
    const productItem = event.target.closest('.product-item');
    const productTitle = productItem.querySelector('.text-small div')?.textContent?.trim();
    
    // Use custom add to cart that shows notification instead of opening cart
    return this.customAddToCart(selectedVariantId, productTitle)
      .then(cart => {
        console.log('Product added to cart successfully:', cart);
        
        // Hide the size picker after adding to cart
        this.hideFormAfterAddToCart(event);
        
        return cart;
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        throw error;
      })
      .finally(() => {
        // Reset plus button state
        if (plusButton && addingText) {
          this.resetPlusButtonState(plusButton, addingText);
        }
      });
  },
  
  customAddToCart: function(variantId, productTitle) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
      
      // Update cart contents immediately
      return fetch('/cart.js');
    })
    .then(response => response.json())
    .then(async cart => {
      // Use centralized cart update function for consistency
      if (window.updateCart) {
        await window.updateCart(cart);
      } else {
        // Fallback to individual functions if updateCart is not available
        if (window.updateMenuCart) {
          window.updateMenuCart(cart);
        }
        if (window.updateMainCart) {
          window.updateMainCart(cart);
        }
        if (window.updateCartCount) {
          window.updateCartCount(cart.item_count);
        }
        
        // Update free shipping progress
        if (window.updateFreeShippingProgress) {
          window.updateFreeShippingProgress(cart);
        }
      }
      
      // Open cart drawer instead of showing notification
      if (window.toggleCartDrawer) {
        window.toggleCartDrawer();
      }
      
      // Show the menu cart footer and notes section immediately
      const menuCartFooter = document.querySelector('.menu-cart-footer');
      const cartNotesSection = document.querySelector('.cart-notes-section');
      if (menuCartFooter) {
        menuCartFooter.style.display = 'block';
      }
      if (cartNotesSection) {
        cartNotesSection.style.display = 'block';
      }
      
      return cart;
    });
  },
  


  fallbackAddToCart: function(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
      
      // Update cart contents immediately
      return fetch('/cart.js');
    })
    .then(response => response.json())
    .then(async cart => {
      // Use centralized cart update function for consistency
      if (window.updateCart) {
        await window.updateCart(cart);
      } else {
        // Fallback to individual functions if updateCart is not available
        if (window.updateMenuCart) {
          window.updateMenuCart(cart);
        }
        if (window.updateMainCart) {
          window.updateMainCart(cart);
        }
        if (window.updateCartCount) {
          window.updateCartCount(cart.item_count);
        }
        
        // Update free shipping progress
        if (window.updateFreeShippingProgress) {
          window.updateFreeShippingProgress(cart);
        }
      }
      
      // Open cart drawer
      if (window.toggleCartDrawer) {
        window.toggleCartDrawer();
      }
      
      // Show the menu cart footer and notes section immediately
      const menuCartFooter = document.querySelector('.menu-cart-footer');
      const cartNotesSection = document.querySelector('.cart-notes-section');
      if (menuCartFooter) {
        menuCartFooter.style.display = 'block';
      }
      if (cartNotesSection) {
        cartNotesSection.style.display = 'block';
      }
      
      return cart;
    });
  },
  
  hideFormAfterAddToCart: function(event) {
    const button = event.target;
    const productItem = button.closest('.product-item');
    const form = productItem.querySelector('.product-item-form');
    const toggleButton = productItem.querySelector('.toggle-product-form');
    
    if (form && toggleButton) {
      const iconPlus = toggleButton.querySelector('.icon-plus');
      const iconMinus = toggleButton.querySelector('.icon-minus');
      
      form.classList.add('hidden');
      if (iconPlus) iconPlus.style.display = 'block';
      if (iconMinus) iconMinus.style.display = 'none';
    }
  },

  resetPlusButtonState: function(button, addingTextElement) {
    // Remove the "adding..." text
    if (addingTextElement && addingTextElement.parentNode) {
      addingTextElement.parentNode.removeChild(addingTextElement);
    }
    
    // Reset button state
    button.disabled = false;
    button.style.opacity = '';
  }
};

// Enhanced event listener for product item variant buttons
document.addEventListener('DOMContentLoaded', function() {
  // Handle variant button clicks specifically for product items with higher priority
  document.addEventListener('click', function(event) {
    const variantButton = event.target.closest('.variant-button');
    
    // Only handle buttons inside product-item-form
    if (variantButton && variantButton.closest('.product-item-form')) {
      event.preventDefault();
      event.stopPropagation();
      
      if (variantButton.disabled) {
        console.log('Variant button is disabled');
        return;
      }
      
      const form = variantButton.closest('.product-item-form');
      const formId = form?.dataset.formId;
      const variantId = variantButton.dataset.variantId;
      
      console.log('Variant button clicked:', { formId, variantId });
      
      if (formId && variantId && window.ProductItemForm) {
        // Set loading state
        const originalText = variantButton.textContent;
        variantButton.textContent = '...';
        variantButton.disabled = true;
        variantButton.style.opacity = '0.7';
        
        // Directly add to cart for product items
        window.ProductItemForm.addToCart(formId, variantId, event)
          .catch(error => {
            console.error('Failed to add product item to cart:', error);
          })
          .finally(() => {
            // Reset button state
            variantButton.textContent = originalText;
            variantButton.disabled = false;
            variantButton.style.opacity = '';
          });
      } else {
        console.error('Missing data for variant button click:', { formId, variantId });
      }
      
      return false; // Prevent any other event handling
    }
  }, true); // Use capture phase to handle before variant-selector.js
}); 